export default __webpack_public_path__ + "static/media/chevron_right.7dc06d11.svg";